import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=757a2b12&scoped=true"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=757a2b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a2b12",
  null
  
)

export default component.exports